module.exports = __webpack_public_path__ + "static/media/Lawrence statue c. 1920.ff21c436.jpg";